module.exports = __webpack_public_path__ + "static/media/icon_armory.b29814f3.png";